import * as actionTypes from "../actions";

var initialState = {
    color: '',
    rateCall: false,
    rateData: {},
    generalRateData:{},
    generalAutoRate:{},
};

const rateReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.IS_RATE_LOADING: {
            return {
                ...state,
                is_rateLoading: true
            };
        }
        case actionTypes.RATE_UPDATE: {
            return {
                ...state,
                rateData: action?.payload,
                is_rateLoading: false,
                rateCall: true
            };
        }
        case actionTypes.GENERAL_RATE_UPDATE: {
            return {
                ...state,
                generalRateData: action?.payload,
                is_rateLoading: false,
                rateCall: true
            };
        }
        case actionTypes.GENERAL_AUTO_RATE_UPDATE: {
            return {
                ...state,
                generalAutoRate: action?.payload,
                is_rateLoading: false,
                rateCall: true
            };
        }
        default: {
            return {
                ...state,
            };
        }
    }
};


export default rateReducer;